import { ref } from 'vue'

import { createSharedComposable } from '@vueuse/core'
import { layoutState, setLayoutState } from '@/composables/usePageLayout'
import { RootViews } from '@/types/pageLayout'
import type {
  AgentCategory,
  AgentsData,
  ConversationsData,
  TicketCategory,
  TicketListFilters,
} from '../components/visualFilters/types'
import { StatisticalDistributionPeriod } from '../types'

export default createSharedComposable(() => {
  const showVisualFilters = ref(false)
  const visualFiltersInitialized = ref(false)
  const visualFilterParams = ref<TicketListFilters | null>(null)
  const timePeriod = ref(StatisticalDistributionPeriod.Last30Days)

  const resetVisualFilters = () => {
    showVisualFilters.value = false
    visualFilterParams.value = null
    if (layoutState.value.leftSidebar !== 'list') setLayoutState(RootViews.Conversations, { leftSidebar: 'list' })
  }

  const handleVisualFilterPane = () => {
    visualFiltersInitialized.value = true
    showVisualFilters.value = !showVisualFilters.value
    setLayoutState(RootViews.Conversations, { leftSidebar: undefined, rightSidebar: 'list' })
  }

  const categoriesInitialized = ref(false)
  const initializingSubCategoriesError = ref(false)
  const conversationsCategories = ref<TicketCategory[]>([])
  const conversationsData = ref<ConversationsData | null>(null)
  const conversationsDataLoading = ref(true)
  const conversationsDataError = ref(false)
  const agentsCategories = ref<AgentCategory[]>([])
  const agentsData = ref<AgentsData | null>(null)
  const agentsDataLoading = ref(true)
  const agentsDataError = ref(false)
  const selectedSlices = ref({
    conversations: [{ category: 'ROOT', values: [''] }],
    agents: [{ category: 'ROOT', values: [''] }],
  })

  return {
    showVisualFilters,
    visualFiltersInitialized,
    visualFilterParams,
    timePeriod,
    resetVisualFilters,
    handleVisualFilterPane,
    categoriesInitialized,
    initializingSubCategoriesError,
    conversationsCategories,
    conversationsData,
    conversationsDataLoading,
    conversationsDataError,
    agentsCategories,
    agentsData,
    agentsDataLoading,
    agentsDataError,
    selectedSlices,
  }
})
